import styled from 'styled-components';

export const Heading = styled.h1`
  text-align: center;
  font-size: 5rem;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const LoaderBox = styled.div`
  padding: 3rem 0;
  display: flex;
  justify-content: center;
`;
